<template>
  <BaseCRUDPageLayout :links="links">
    <template v-slot:tableName> إنشاء مسار جديد </template>
    <v-container>
      <v-row>
        <v-col cols="12">
          <CreateTrainingProgramForm />
        </v-col>
      </v-row>
    </v-container>
    
    <!-- Video Upload Progress Dialog -->
    <VideoUploadProgress />
  </BaseCRUDPageLayout>
</template>

<script>
import CreateTrainingProgramForm from "../components/forms/CreateTrainingProgramForm.vue";
import VideoUploadProgress from "../components/VideoUploadProgress.vue";

export default {
  data() {
    return {
      links: [
        {
          text: "الصفحة الرئيسية",
          href: "/",
          disabled: false,
        },
        {
          text: "مسارات المنح التدريبية",
          href: "/training-programs",
          disabled: false,
        },
        {
          text: "إنشاء مسار جديد",
          disabled: true,
        },
      ],
    };
  },
  components: { CreateTrainingProgramForm, VideoUploadProgress },
};
</script>
